import angular from 'angular'

import { $q, $window } from '../ng-compat/imports'

/**
 * Intercepts $http response errors and redirects to the billing page if the error was a 402 StatusPaymentRequired
 *
 * @module webregister.http.RedirectBillingOn402
 */
function RedirectBillingOn402() {
  let _hasEncountered402 = false

  return {
    hasEncountered402() {
      return _hasEncountered402
    },

    responseError(response: $TSFixMe) {
      if (response.status === 402) {
        _hasEncountered402 = true

        $window.location.href = '/billing'
      }

      return $q.reject(response)
    },
  }
}

angular
  .module('webregister.http')
  .factory('redirectBillingOn402', RedirectBillingOn402)
